
import { computed } from "vue";
import Base from "@/components/base/Base.vue";
import ChallengeService from "@/services/challenge.service";
import {ChallengeSettings} from "@/model/challengeSettings.model.ts";
import { ScreenType } from "@/enum/screen.type";
import { IFileModel } from "@/model/FileModel.model";
export default class CreateChallenge extends Base {
  public settingsChallenge = computed<ChallengeSettings>(
    () => this.store.getters.getChallengeSettingSelected
  ).value;
  public listFileUpload = computed<IFileModel[]>(() => this.store.getters.getListFilesUpload).value;
  publishChallenge() {
    ChallengeService.createChallenge(this.settingsChallenge, this.currentUser).subscribe((result: any) => {
      this.redirectTo(ScreenType.hall);
      // const challengeId = result.response[0]._id;
      // this.uploadImageChallenge(challengeId);
    })
    // const challengeId = "5fe71764495d2e160464b1f7";
    // const dataUpdatte = "XYZ";
    // ChallengeService.updateChallenge(challengeId, dataUpdatte).subscribe(result => {
    //   console.log(result);
    // })
  }

  // uploadImageChallenge(challengeId: string) {
  //   this.listFileUpload.forEach(image => {
  //     const imageName = `${image.imageType}-${challengeId}`;
  //     ChallengeService.uploadImages(image, imageName).subscribe((imageUrl)=>{
  //       console.log(imageUrl);
  //     this.redirectTo(ScreenType.hall);
  //     });
  //   })
  // }
}
